/**
 * Application entry point.
 * Load config, resolve app list, start "osd", "system" applications in background.
 * If the config contains authorization application - launch it.
 * Start launcher after all operations.
 *
 * @author Igor Zapororzhets <deadbyelpy@gmail.com>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 *
 * @flow
 */

'use strict';

/* eslint-disable */
// make sure core have access to API (RTS API wrapper sometimes too slow)
// TODO: move to better place
window.dvbManager = window.top.dvbManager;
window.epgManager = window.top.epgManager;
window.gSTB = window.top.gSTB;
window.pvrManager = window.top.pvrManager;
window.stbDownloadManager = window.top.stbDownloadManager;
window.stbStorage = window.top.stbStorage;
window.stbUpdate = window.top.stbUpdate;
window.stbUPnP = window.top.stbUPnP;
window.stbWebWindow = window.top.stbWebWindow;
window.stbWindowMgr = window.top.stbWindowMgr;
window.timeShift = window.top.timeShift;
window.stbPlayerManager = window.top.stbPlayerManager;

var // utility modules
    parse = require('cjs-parse-query'),
    // preloader = require('spa-preloader'),

    // project modules
    coreManager   = require('./modules/kernel/core.manager'),
    taskManager   = require('./modules/system/task.manager'),
    intentManager = require('./modules/system/intent.manager'),
    config        = require('./modules/tools/config'),

    // remove this require, after magcore-osd-base refactoring
    widget = require('./components/widget'),

    // etc.
    // store GET parameters in variable
    queryParameters = parse(document.location.search.substring(1)),

    platformEvent = require('./modules/system/platform.event'),
    splash        = require('./components/splash'),
    Storage       = require('./modules/system/storage'),

    packages   = [],
    packageMap = {};

/* eslint-enable */

function switchCorePackage ( source, target ) {
    var xhr         = new XMLHttpRequest(),
        packagePath = location.protocol + '//' + location.host + location.pathname.replace(source, target) + location.search + location.hash;

    xhr.open('GET', packagePath);

    xhr.onload = function () {
        if ( this.status === 200 ) {
            location.href = packagePath;
        }
    };

    xhr.send();
}

if ( !NANOCORE ) {
    if ( queryParameters.buildDate ) {
        window.splashAppVersion.innerText = queryParameters.buildDate;
    }
}

if ( DEVELOP ) {
    debug('kernel')('location ' + window.location.href);
}

// require platform api
require('./modules/system/api');
// add platform-dependent shims, if needed
require('./modules/system/shims');
// async css load
require('./css');

// create globals for plugins
// legacy variables
window.MODE_PORTAL = MODE === 'PORTAL';
window.MODE_STALKER = MODE === 'MINISTRA';
// new way
window.MODE = MODE;

// create abstract storage in core.storage
window.extendCorePrototype('Storage', Storage);

// first-load actions if platform needs
platformEvent.init();

window.getCoreInstance = window.getCoreInstanse = function ( contentWindow ) {
    var core = coreManager.getInstance(contentWindow);

    // remove this code, after magcore-osd-base refactoring
    core.widget      = widget;
    core.system      = true;
    core.packages    = packages;
    core.packageMap  = packageMap;
    core.taskManager = taskManager;

    core.updatePackages = function ( apps ) {
        packages.splice(0);
        Object.keys(packageMap).forEach(function ( packageName ) {
            delete packageMap[packageName];
        });
        apps.forEach(function ( item ) {
            packageMap[item.packageName] = item;
            packages.push(item);
        });
    };

    core.reload = function ( url ) {
        Storage.forceFlush();

        if ( PLATFORM === 'MAG' || NANOCORE ) {
            require('./modules/platforms/mag/utils').reload(url);
        } else if ( url ) {
            location.href = url;
        } else {
            location.reload();
        }
    };

    core.reboot = function () {
        Storage.forceFlush();

        if ( PLATFORM === 'MAG' || NANOCORE ) {
            require('./modules/platforms/mag/utils').reboot();
        }
    };

    return core;
};

// create core for core, we need to go deeper...
window.system = window.core = window.getCoreInstance(window);
window.system.queryParameters = queryParameters;
window.core.storage = new window.core.constructor.prototype.Storage(PACKAGE_NAME);

window.addEventListener('keydown', function ( event ) {
    var eventForwarder = require('./modules/system/event.forwarder'),
        eventName;

    if ( event.keyCode === 0 ) {
        return;
    }

    if ( event.keyCode === 9 ) {
        event.preventDefault();
    }

    eventName = 'keydown:' + require('spa-keyboard-event-parser')(event);

    if ( DEVELOP ) {
        debug('main window')('event ' + event.keyCode);
    }

    eventForwarder(eventName, event);
});


/* eslint max-lines-per-function: ['error', {max: 220, skipBlankLines: true, skipComments: true}] */
/* eslint max-statements: ['error', 100] */
config.load(queryParameters, function ( error ) {
    var index      = -1,
        authorizer = null,
        daemons    = {},
        height, size, $link,
        packageName, authorizerInstance;


    if ( error ) {
        if ( NANOCORE ) {
            window.splash = document.body.appendChild(document.createElement('div'));
            window.splash.style.backgroundColor = '#1B5E20';
            window.splash.style.overflow = 'scroll';
            window.splash.innerHTML = '<pre tabindex="1" ' +
                'style="padding: 40px; overflow-y: scroll; height: ' +
                screen.height + 'px; width: ' +
                screen.width + 'px;font-family: monospace;' +
                'font-size: 16px; text-align: left;padding: 10px;color: #fff;">' +
                error +
                '\nCore Panic: Fatal Exception</pre>';
            window.splash.firstChild.focus();
        } else {
            window.splash.style.backgroundColor = '#1B5E20';
            window.splash.style.overflow = 'scroll';
            window.splash.innerHTML = '<pre tabindex="1" ' +
                'style="padding: 40px; overflow-y: scroll; height: ' +
                screen.height + 'px; width: ' +
                screen.width + 'px;font-family: monospace;' +
                'font-size: 16px; text-align: left;padding: 10px;color: #fff;">' +
                error +
                '\nCore Panic: Fatal Exception</pre>';
            window.splash.firstChild.focus();
        }

        return;
    }

    if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
        // TODO: remove when http://192.168.1.220:3000/issues/22236 was implemented
        if ( typeof gSTB.SetSubtitlesFont === 'undefined' ) {
            console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! gSTB.SetSubtitlesFont: ' + gSTB.SetSubtitlesFont);
            gSTB.SetSubtitlesFont = function () {};
        }
        if ( queryParameters.backendHost ) {
            config.data.options.stalkerHost = queryParameters.backendHost;
            config.data.options.stalkerApiPath = '/stalker_portal/api/v3/';
            config.data.options.stalkerAuthPath = '/stalker_portal/auth/token.php';
            config.data.options.pingTimeout = 120000;
            config.data.options.stalkerLoaderPath = '/stalker_portal/c/';
        }
    }

    if ( NANOCORE ) {
        for ( index = 0; index < config.data.apps.length; index++ ) {
            if ( config.data.apps[index].type === 'launcher' ) {
                window.splash.className = 'container';
                splash.show(config.data.apps[index]);
                if ( queryParameters.buildDate ) {
                    window.splashAppVersion.innerText = queryParameters.buildDate;
                }
                break;
            }
        }
        index = -1;
    }

    if ( queryParameters.backendHost ) {
        // emulator versions
        config.data.options.stalkerHost = queryParameters.backendHost;
        config.data.options.stalkerApiPath = '/stalker_portal/api/v3/';
        config.data.options.stalkerAuthPath = '/stalker_portal/auth/token.php';
        config.data.options.pingTimeout = 120000;
        config.data.options.stalkerLoaderPath = '/stalker_portal/c/';
        config.data.options.sap = queryParameters.backendHost + '/stalker_portal/server/api/sap.php';
    }

    core.config = config.data;
    size = config.data.apps.length - 1;

    require('./modules/kernel/plugin.loader').basePath = config.data.options.pluginsPath;

    window.core.dependencyManager = require('./modules/kernel/plugin.loader');

    window.extendCorePrototype('theme', {
        path: config.data.theme,
        vars: config.data.themeVars
    });
    window.extendCorePrototype('themes', config.data.themes);

    while ( index < size ) {
        ++index;
        packageName = config.data.apps[index].packageName;

        switch ( config.data.apps[index].type ) {
            case 'auth':
                authorizer = config.data.apps[index];
                break;

            case 'plugin':
                // dependencyManager.packages[packageName] = JSON.parse(JSON.stringify(config.data.apps[index]));
                // dependencyManager.packages[packageName].depedents = [];
                // dependencyManager.packages[packageName].instance = null;
                // dependencyManager.packageNameToName[config.data.apps[index].name] = packageName;
                if ( DEVELOP ) {
                    debug('dependency')('add plugin ' + packageName + ' to system');
                }
                if ( config.data.apps[index].daemon ) {
                    daemons[config.data.apps[index].packageName] = config.data.apps[index].version;
                }
                /* eslint no-fallthrough: 0 */

            default:
                packages.push(JSON.parse(JSON.stringify(config.data.apps[index])));
                packageMap[packageName] = packages[packages.length - 1];
                break;

            //case 'driver':
            //    (function ( index ) {
            //        loaders.push(function ( done ) {
            //            if ( DEVELOP ) {
            //                debug('driver')(index);
            //            }
            //            var task = taskManager.runApp({
            //                config: config.data.apps[index],
            //                visible: false,
            //                onload: function () {
            //                    done(false, task);
            //                },
            //                onerror: function ( url ) {
            //                    if ( DEVELOP ) {
            //                        debug('driver')(url);
            //                        debug('driver')(config.data.apps[index].name);
            //                    }
            //                }
            //            });
            //        });
            //    })(index);
            //    break;
        }

        intentManager.resolveActionsConfig(config.data.apps[index]);
    }

    require('./modules/kernel/plugin.loader').load({
        dependencies: daemons,
        dependencyReady: function ( error, plugin ) {
            if ( error ) {
                return;
            }

            if ( DEVELOP ) {
                debug('daemon')('onInit: ' + plugin.name + ': ' + typeof plugin.instance.onInit);
            }
            if ( typeof plugin.instance.onInit === 'function' ) {
                /* eslint no-empty-function: 0 */
                if ( DEVELOP ) {
                    debug('daemon')('onInit: ' + plugin.name);
                }
                if ( !plugin.daemonLoaded ) {
                    plugin.daemonLoaded = true;
                    plugin.instance.onInit({
                        storage: require('./modules/kernel/plugin.loader').getPluginStorage(plugin.name),
                        options: plugin.options,
                        path: plugin.path
                    }, function ( error, instance ) {
                        if ( DEVELOP ) {
                            debug('daemon')('loaded + push? ' + (!!error));
                        }
                        if ( !error && typeof instance === 'object' && typeof instance.emit === 'function' ) {
                            taskManager.daemons.push(instance);
                        }
                    });
                }

                return;
            }

            if ( DEVELOP ) {
                debug('plugin')(plugin.name + ' dont have onInit method');
            }
        }
    });
    // dependencyManager.load({
    //     dependencies: daemons,
    //     dependencyReady: function ( error, plugin ) {
    //         if ( error ) {
    //             return;
    //         }

    //         if ( DEVELOP ) {
    //             debug('daemon')('onInit: ' + plugin.name + ': ' + plugin.instance.onInit);
    //         }
    //         if ( plugin.instance.onInit ) {
    //             /* eslint no-empty-function: 0 */
    //             if ( DEVELOP ) {
    //                 debug('daemon')('onInit: ' + plugin.name);
    //             }
    //             plugin.instance.onInit({
    //                 storage: dependencyManager.getPluginStorage(plugin.name),
    //                 options: plugin.options,
    //                 path: plugin.path
    //             }, function ( error, instance ) {
    //                 if ( DEVELOP ) {
    //                     debug('daemon')('loaded + push? ' + (!!error));
    //                 }
    //                 if ( !error && typeof instance === 'object' && typeof instance.emit === 'function' ) {
    //                     taskManager.daemons.push(instance);
    //                 }
    //             });

    //             return;
    //         }

    //         if ( DEVELOP ) {
    //             debug('plugin')(plugin.name + ' dont have onInit method');
    //         }
    //     }
    // });

    taskManager.init();

    if ( authorizer === null ) {
        taskManager.daemons.forEach(function ( daemon ) {
            if ( DEVELOP ) {
                try {
                    debug('plugin')('emit system:start event');
                    daemon.emit('system:start');
                } catch ( error ) {
                    debug('plugin')('emit system:start error: ' + error);
                }
            } else {
                daemon.emit('system:start');
            }
        });
        require('./modules/system/init');
    } else {
        if ( DEVELOP ) {
            debug('system')('load auth app');
        }

        // remove this code, after magcore-osd-base refactoring
        height = window.innerHeight || window.screen.height;
        switch ( height ) {
            case 480:
            case 576:
            case 720:
            case 1080:
                break;

            default:
                height = 720;
                break;
        }

        $link      = document.createElement('link');
        $link.rel  = 'stylesheet';
        $link.href = window.core.theme.path + height + '.css';
        document.head.appendChild($link);

        authorizerInstance = taskManager.runApp({
            config: authorizer,
            visible: true,
            onready: function () {
                if ( DEVELOP ) {
                    debug('system')('auth app ready');
                }
                // require('./modules/system/init');
            },
            onload: function () {
                if ( DEVELOP ) {
                    debug('system')('auth app loaded');
                }
                // taskInstance.core.once('ready', function ( event ) {
                //     if ( DEVELOP ) {
                //         debug('system')('auth app ready');
                //     }
                //     event = event || {};
                //     if ( !event.stop ) {
                //         require('./modules/system/init');
                //     }
                // });
                // taskInstance.core.once('show', splash.init);
            }
        });

        authorizerInstance.core.once('ready', function ( event ) {
            if ( DEVELOP ) {
                debug('system')('auth app ready');
            }
            event = event || {};
            if ( !event.stop ) {
                taskManager.daemons.forEach(function ( daemon ) {
                    try {
                        // console.log(daemon.toString());
                        daemon.emit('system:start');
                    } catch ( error ) {
                        if ( DEVELOP ) {
                            debug('plugin')('emit system:start error: ' + error);
                        }
                    }
                });
                authorizerInstance.$iframe.hide();
                authorizerInstance.core.emit('hide', {
                    source: window.core.SOURCES.SYSTEM
                });
                require('./modules/system/init');
            }
        });
        authorizerInstance.core.once('show', splash.init);
    }
});

if ( DEVELOP ) {
    window.addEventListener('blur', function () {
        debug('core')('blur');
    });
}


window.addEventListener('unload', function () {
    if ( platformEvent.unload ) {
        platformEvent.unload();
    }
});

window.addEventListener('focus', function () {
    if ( DEVELOP ) {
        debug('core')('focus');
    }
    if ( taskManager.topApp ) {
        taskManager.topApp.$iframe.contentWindow.focus();
    } else if ( taskManager.focusedApp ) {
        taskManager.focusedApp.$iframe.contentWindow.focus();
    } else if ( taskManager.launcher ) {
        taskManager.launcher.$iframe.contentWindow.focus();
    }
});

document.addEventListener('visibilitychange', function () {
    if ( document.visibilityState === 'visible' ) {
        if ( DEVELOP ) {
            debug('core')('visibilitychange ' + document.visibilityState);
        }

        if ( taskManager.topApp ) {
            taskManager.topApp.$iframe.contentWindow.focus();
            taskManager.topApp.core.emit('focus');
        } else if ( taskManager.focusedApp ) {
            taskManager.focusedApp.$iframe.contentWindow.focus();
            taskManager.focusedApp.core.emit('focus');
        } else if ( taskManager.launcher ) {
            taskManager.launcher.$iframe.contentWindow.focus();
            taskManager.launcher.core.emit('focus');
        }
    }
});

if ( DEVELOP ) {
    window.core.addListener('keydown:68ca', function () {
        switchCorePackage('magcore-core-debug', 'magcore-core');
    });
} else if ( window.core.environment.debug ) {
    window.core.addListener('keydown:68ca', function () {
        switchCorePackage('magcore-core', 'magcore-core-debug');
    });
}
